import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import dataAids from '../constants/dataAids';
import renderModes from '../constants/renderModes';
import * as MetricsEvents from '../constants/metrics';
import { trackC1 } from '../utils/trackMetric';

const styles = {
  modalBackground: {
    position: 'absolute',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'transparent',
    paddingHorizontal: 'small'
  }
};

const EmptyServiceListModal = ({
  ctaUrl,
  staticContent,
}) => {
  const {
    Element: { Block },
    Component: { ZeroStateOverlay }
  } = UX2;

  useEffect(() => {
    trackC1(MetricsEvents.APPOINTMENTS_ZERO_STATE_IMPRESSION);
  }, []);

  const openUrl = event => {
    trackC1(MetricsEvents.APPOINTMENTS_ZERO_STATE_ADD_SERVICES_CTA_CLICKED);

    event.stopPropagation();
    window.open(ctaUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <Block style={ styles.modalBackground } data-aid={ dataAids.EMPTY_CONTAINER_RENDERED }>
      <ZeroStateOverlay
        renderMode={ renderModes.EDIT }
        title={ staticContent.emptyServiceListTitle }
        description={ staticContent.emptyServiceListDescription }
        button={{
          onClick: openUrl,
          children: staticContent.emptyServiceListCallToAction
        }}
      />
    </Block>
  );
};

EmptyServiceListModal.propTypes = {
  ctaUrl: PropTypes.string,
  category: PropTypes.string,
  staticContent: PropTypes.object.isRequired
};

export default EmptyServiceListModal;
